// Simple client-side image compression and resize
// Scales the longest side to maxSize and encodes as WebP (or given mime) at quality
export async function compressImage(file, { maxSize = 640, mime = 'image/webp', quality = 0.82 } = {}) {
  try {
    const img = await loadImageFromFile(file);
    const { width, height } = scaleDimensions(img.width, img.height, maxSize);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, mime, quality));
    // Fallback to original if conversion failed
    return blob || file;
  } catch {
    return file; // On any error, return original
  }
}

function scaleDimensions(w, h, max) {
  if (w <= max && h <= max) return { width: w, height: h };
  const ratio = w > h ? max / w : max / h;
  return { width: Math.round(w * ratio), height: Math.round(h * ratio) };
}

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
